/**
 * Created For: 地图相关接口
 * Author: chenLiYan.
 * Date: 2018/11/30 0030 15:43.
 */
import request from '@/utils/request'
export function salesFlowList(data) {
  return getData('stdSalesFlow', data)
}

export function getData(code, data) {
  return request({
    url: '/v1/channel/' + code,
    method: 'post',
    data
  })
}

export function queryMeta(code) {
  return request({
    url: '/api/meta/' + code + '/query',
    method: 'get'
  })
}

export function salesFlowMeta() {
  return queryMeta('stdSalesFlow')
}

export function purchaseFlowMeta() {
  return queryMeta('stdPurchaseFlow')
}

export function inventoryFlowMeta() {
  return queryMeta('stdInventoryFlow')
}

export function areaTree(params, flowType = 'sales') {
  const normalized = Array.isArray(flowType) ? flowType[0] : flowType
  const type = normalized === 'purchase' ? 'purchasing' : 'sales'
  return request({
    url: `/v1/channel/ddi_info/${type}`,
    method: 'get',
    params
  })
}

export function companySalesNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/companyName/sales',
    method: 'get',
    params
  })
}

export function productSalesNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/products/sales',
    method: 'get',
    params
  })
}

export function customerSalesNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/customers/sales',
    method: 'get',
    params
  })
}

export function companyPurchaseNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/companyName/purchasing',
    method: 'get',
    params
  })
}

export function productPurchaseNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/products/purchasing',
    method: 'get',
    params
  })
}

export function customerPurchaseNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/customers/purchasing',
    method: 'get',
    params
  })
}

export function suppliersPurchaseNameList(params) {
  return request({
    url: '/v1/channel/ddi_info/suppliers/purchasing',
    method: 'get',
    params
  })
}
